export const earn = {
  jdzb: "Ganhe moedas facilmente",
  jryd: "As finanças são sábias e podemos progredir juntos",
  jrbk: "Junte-se ao Biking para ganhar moedas facilmente, com inovação ilimitada para maximizar os benefícios de seus ativos digitais",
  zbz: "Ganhando moedas",
  ljsy: "Renda acumulada",
  zrsy: "Ganhos de ontem",
  hq: "Atual",
  cknh: "Anualização de referência",
  sqjd: "Progresso da assinatura",
  sg: "Assinatura",
  qbcp: "Todos os produtos",
  cz: "Reiniciar",
  qx: "Termo",
  question1: "1. O que é ganhar dinheiro?",
  question1_text:
    "Ganhar moedas é uma plataforma de serviço completa criada pela BIKING para ajudar os usuários a descobrir oportunidades para uma variedade de produtos de retenção de moeda. Atualmente, a maneira simples de ganhar moedas é Yubibao (depósito e retirada a qualquer momento), e mais produtos serão lançado no futuro para fornecer aos usuários uma ampla gama de opções de produtos.",
  question2: "2. O que é anualização de referência?",
  question2_text:
    "A receita do ganho de tokens atualmente são os juros sobre os tokens depositados. A anualização de referência é a anualização dos juros sobre os tokens depositados. Por exemplo, os primeiros 1.000U de um produto são baseados na anualização de referência de 12%, e os primeiros 1.000U além dos primeiros 1.000U são baseados na anualização de referência de. 2%. A anualização total de referência dos juros é de 14%.",
  question3: "3. Quando começa o cálculo/liquidação de juros?",
  question3_text:
    "Ao assinar produtos diferentes, o tempo de acumulação/liquidação de juros pode ser diferente. Tomemos como exemplo o atual ganho simples diário baseado em juros do USDT, os juros vencem às 2h (UTC+8) do dia seguinte após a compra dos produtos atuais do USDT. Às 5h (UTC+8) no horário T+1 (ou seja, horário de compra T+2), serão emitidos os juros do dia anterior à liquidação do dia seguinte;",
  question4: "4. Qual o investimento restante?",
  question4_text:
    "O valor restante do investimento é o valor do produto financeiro que você ainda pode assinar<br/>O valor restante do investimento = valor total da compra do produto - o valor que você assinou",
  xzmbfs: "Selecione o método de depósito/compra",
  nhsyl: "Taxa de retorno anualizada e prazo:",
  sl: "Quantidade",
  qitou: "Iniciando investimento",
  max: "Máximo",
  kzcsl: "Este é o valor que pode ser transferido da conta de capital",
  sykt: "O restante pode ser investido",
  syktsl:
    "O valor restante do investimento é o valor que você ainda pode assinar",
  syktsx:
    "Valor restante do investimento = valor total da compra do produto - a quantidade que você assinou (não superior ao limite de investimento individual {amount}{coin})",
  jlgz: "Regras de recompensa",
  jd1: "Escada 1: Primeiro {amount}{coin}",
  ptjl: "Recompensa da plataforma",
  jd2: "Escada 2: Maior que a primeira {amount}{coin}",
  jd3: "Escada 3: Maior que {amount}{coin}",
  jd22:"Escada ",
  grsgsx: "O limite máximo da assinatura pessoal é {amount}{coin}",
  gz: "Regras",
  sgsj: "Tempo de assinatura",
  xianzai: "Agora",
  qxsj: "Horário de início dos juros",
  lxrz: "Os juros são registrados",
  c2c: "C2C comprar moedas",
  lhxz: "Escolhas flexíveis, melhores preços",
  lcjd: "Processo simples, transação rápida",
  crszhb: "Depositar moeda digital da carteira ou exchange",
  zcsl: "Quantidade de ativos",
  dzsy: "Receita recebida",
  lcxx: "Informações de Gestão Financeira",
  zt: "Status",
  sh: "Redenção",
  sgje: "Valor da assinatura",
  sgzj: "O primeiro {amount}{coin} de fundos de assinatura pode render {value}% de bônus anual",
  dyklqje:
    "Qualquer pessoa com mais de {amount}{coin} pode ganhar {value}% de recompensa anual",
  grsged: "O valor da assinatura pessoal é {amount}～{amoun2}{coin}",
  shsl: "Quantidade de resgate",
  srshsl: "Insira o valor do resgate",
  ksh: "Resgatável:",
  haode: "Ok",
  zcsg: "Inscreva-se novamente",
  sjdzsl: "Quantidade real recebida",
  shsj: "Tempo de resgate",
  jssj: "Tempo de liquidação",
  sgcg: "Assinatura bem-sucedida",
  shcg: "Resgate bem-sucedido",
  dq: "Regularmente",
  yjsdd: "Ordem liquidada",
  jyjl: "Registro de transação",
  hqjdzb: "Ganhe moedas facilmente com depósitos correntes",
  sy: "lucro",
  wwc: "Não concluído",
  xmlx: "tipo de projeto",
  hqjdzbcp: "Ganhe dinheiro facilmente com depósitos à ordem. É um produto financeiro seguro criado pela Biking. Suporta depósitos e retiradas 24 horas por dia e os juros são calculados por hora.",
  nh: "Anualização",
  zhzchz: "Transferência de ativos da conta, simples e rápida",
  qsrsl: "Por favor insira a quantidade",
  yjssymx: "Detalhes da renda liquidada",
  mx: "Detalhes",
  qwsmrz: "Ir para autenticação de nome real",
  jxwcsmrz: "1. Esta atividade está aberta apenas para usuários que concluíram a autenticação de nome real. Cada usuário tem apenas uma chance de participar desta atividade.",
  dqcked: "2. O valor fixo do depósito de cada usuário é {min}~{max}{coin}, e o sistema o resgatará automaticamente na conta no vencimento",
  cpbntjsh: "3. Este produto não pode ser resgatado antecipadamente",
  anzh: "4. Após a assinatura do produto, o pool total é 0 e o botão fica acinzentado",
  smrzyh: "A atividade está disponível apenas para usuários que concluíram a autenticação de nome real.",
  jxcjyc: "Cada usuário elegível só pode participar uma vez",
  ygsy: "Receita estimada",
  scqx: "Período de bloqueio",
  qixian: "{min}ésimo dia (total {máx} dias)",
};



// WEBPACK FOOTER //
// ./src/i18n/lang/earn/pt_BR.js